module.exports = __webpack_public_path__ + "assets/img/a-1_fanhuidingbu.ace3721a.svg";